import React from 'react'
import { AmplitudeProvider } from 'react-amplitude-hooks'
import amplitudeService from 'helpers/amplitude.helper'

export const RankmiAmplitudeWrapper: React.PropsWithChildren<any> = ({
  children,
}) => {
  let ChildrenNode: React.ReactNode = children

  try {
    const instanceClient = amplitudeService.getAmplitudeInstance()
    const apiKey = amplitudeService.getApiKey()
    const userId = amplitudeService.getUserId()

    ChildrenNode = (
      <AmplitudeProvider
        apiKey={apiKey}
        userId={userId}
        amplitudeInstance={instanceClient}
      >
        {children}
      </AmplitudeProvider>
    )
  } catch (e) {
    ChildrenNode = children as React.ReactNode
  }

  return <div className="amplitudejs-wrapper">{ChildrenNode}</div>
}
